import { render, staticRenderFns } from "./MessageAudio.vue?vue&type=template&id=577277a3&"
import script from "./MessageAudio.vue?vue&type=script&lang=js&"
export * from "./MessageAudio.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports